<div class="upload-files-container">
  <app-video-uploader
    [mediaForm]="mediaBlockService.mediaForm!"
    [contentType]="mediaBlockService.contentType!"
  />
  <app-gps-uploader
    [mediaForm]="mediaBlockService.mediaForm!"
    [contentType]="mediaBlockService.contentType!"
  />
</div>
<app-syncro-status mode="fullscreen" />

<app-syncro-editor />
